import './index.css';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { _404 } from './elements/404';
import { CustomerSearchPage } from './pages/CustomerSearchPage';
import { EditContractPage } from './pages/EditContractPage';
import { EditGroupPage } from './pages/EditGroupPage';
import { AddContractPage } from './pages/AddContractPage';
import { AddGroupPage } from './pages/AddGroupPage';
import { useUserInfo } from './hooks/useUserInfo';
import { RenewContractPage } from './pages/RenewContractPage';
import { PortalHeader } from '@portal_components/components/PortalHeader';
import { PageContainer } from '@portal_components/components/PageContainer';
import { PortalFooter } from '@portal_components/components/PortalFooter';

const router = createBrowserRouter([
  {
    path: '',
    element: <PageContainer className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12 2xl:col-span-11" />,
    children: [
      {
        path: '',
        element: <CustomerSearchPage />
      }
    ]
  },
  {
    path: '/',
    element: <PageContainer className="col-span-12 md:col-span-10 lg:col-span-8 2xl:col-span-6" />,
    children: [
      {
        path: 'editContract/:groupId/:contractId',
        element: <EditContractPage />
      },
      {
        path: 'editGroup/:groupId',
        element: <EditGroupPage />
      },
      {
        path: 'addContract/:groupId',
        element: <AddContractPage />
      },
      {
        path: 'renewContract/:groupId/:contractId',
        element: <RenewContractPage />
      },
      {
        path: 'addGroup',
        element: <AddGroupPage />
      }
    ]
  },
  {
    path: '404',
    element: <_404 />
  }
]);

function App() {
  const { isUserInfoLoading, userInfo } = useUserInfo();

  return (
    <div>
      <PortalHeader title="NHH Contract Portal" navigate={router.navigate} userEmail={userInfo?.user} applications={userInfo?.applications} />
      {isUserInfoLoading && <div className="flex flex-row justify-center">Loading User Info...</div>}
      {userInfo && <RouterProvider router={router} />}
      <PortalFooter />
    </div>
  );
}

export default App;
